import { type StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { createContext } from 'react';

export type GeoContextValue = {
  isReady: boolean;
  regionCode: StateAbbreviation | undefined;
  setRegionCode: (code: StateAbbreviation) => void;
  initialRegionCode: StateAbbreviation | undefined;
};

export const GeoContext = createContext<GeoContextValue | undefined>(undefined);
